
<template>
  <v-app>
    <app-system-bar></app-system-bar>
    <app-bar v-model="drawer"></app-bar>
    <app-navigation
        v-model="drawer"
        :expand-on-hover="expandOnHover"
        :mini="mini"
        @mini="mini = $event"
    ></app-navigation>
    <template v-if="appShowSnackbar">
      <app-snackbar/>
    </template>
    <v-main id="main-content" class="mainback">
      <app-progress-linear/>
      <v-fade-transition mode="out-in">
        <router-view/>
      </v-fade-transition>
      <slot></slot>
    </v-main>
    <app-main-footer/>

    <v-btn
        v-show="topScreen"
        v-scroll="onScroll"
        bottom
        color="primary"
        dark
        fab
        fixed
        :right="!AppRtl"
        :left="AppRtl"
        @click="toTop">
      <v-icon>keyboard_arrow_up</v-icon>
    </v-btn>
  </v-app>
</template>
<style>
.mainback{
  /*background-image: url('/build/images/back.png');*/
  /*background-attachment: fixed;*/
  /*background-position: center;*/
  /*opacity: 50%;*/
}
</style>
<script>
// import AppSnack from '@components/snackbar/Snackbar';
import {mapGetters, mapMutations} from 'vuex';

export default {
  name: 'App',
  components: {
    // AppSnack: () => import( /* webpackChunkName: "Alert" */ '@components/snackbar/Snackbar' )
    // AppSnack
  },
  methods: {
    setDrawer(v) {
      this.navigation = v;
    },
    setMini(v) {
      this.mini = v;
    },
    onScroll(e) {
      if(typeof window === 'undefined') return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.topScreen = top > 20;
    },
    toTop() {
      this.goTo(0);
    },
    Check_Token_Process(){
      if(this.isLogin) {
        let getprocess = Promise.resolve();
        getprocess = this.$axios.get(`check-token`)
         .then(({data}) => {
           if (data && data.data && data.success === true) {
             localStorage.setItem('perms', JSON.stringify(data.data.permissions));
             localStorage.setItem('backend_routes', JSON.stringify(data.data.routes));
             data = data.data
             this.Baruser = data;
           }
         })
         .catch(errordata => {
           console.log(errordata.response);
         });
        getprocess.finally(() => {
          setTimeout(() => {
            this.Check_Token_Process();
          }, 30000)
        });
      }
    },
  },
  data() {
    return {
      // navigation: !this.AppIsMobile,
      navigation: false,
      // mini: !this.AppIsMobile,
      mini: false,
      canExpandOnHover: !this.AppIsMobile,
      topScreen: false,
    };
  },
  computed: {
    drawer: {
      get() {
        return this.navigation;
      },
      set(v) {
        this.setDrawer(v);
      }
    },
    expandOnHover() {
      return !1;
      return !this.AppIsMobile && this.canExpandOnHover;
    },
    appShowSnackbar: {
      set(value) {
        mapMutations('snackbar', ['setShow']).setShow.call(this, value);
      },
      get() {
        return mapGetters('snackbar', ['getShow']).getShow.call(this);
      }
    },
    Baruser: {
      get() {
        return this.$root.authUser || {};
      },
      set(v) {
        this.$root.authUser = v;
      }
    },
  },
  mounted() {
    // this.navigation = !this.AppIsMobile;
    // this.mini = !this.AppIsMobile;
    this.Check_Token_Process();
  }
};
</script>
